// source: pbtypes/gen/microhard_util/microhard_lan_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.microhard_util.MicrohardLanSettingsPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.microhard_util.MicrohardLanSettingsPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.microhard_util.MicrohardLanSettingsPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.microhard_util.MicrohardLanSettingsPb.displayName = 'proto.microhard_util.MicrohardLanSettingsPb';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.toObject = function(opt_includeInstance) {
  return proto.microhard_util.MicrohardLanSettingsPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.microhard_util.MicrohardLanSettingsPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.microhard_util.MicrohardLanSettingsPb.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
mhIp: jspb.Message.getFieldWithDefault(msg, 2, ""),
mhNetmask: jspb.Message.getFieldWithDefault(msg, 3, ""),
mhGateway: jspb.Message.getFieldWithDefault(msg, 4, ""),
computerIp: jspb.Message.getFieldWithDefault(msg, 5, ""),
computerNetmask: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.microhard_util.MicrohardLanSettingsPb}
 */
proto.microhard_util.MicrohardLanSettingsPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.microhard_util.MicrohardLanSettingsPb;
  return proto.microhard_util.MicrohardLanSettingsPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.microhard_util.MicrohardLanSettingsPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.microhard_util.MicrohardLanSettingsPb}
 */
proto.microhard_util.MicrohardLanSettingsPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMhIp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMhNetmask(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMhGateway(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setComputerIp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setComputerNetmask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.microhard_util.MicrohardLanSettingsPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.microhard_util.MicrohardLanSettingsPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.microhard_util.MicrohardLanSettingsPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getMhIp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMhNetmask();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMhGateway();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getComputerIp();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getComputerNetmask();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.microhard_util.MicrohardLanSettingsPb} returns this
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mh_ip = 2;
 * @return {string}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.getMhIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.microhard_util.MicrohardLanSettingsPb} returns this
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.setMhIp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mh_netmask = 3;
 * @return {string}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.getMhNetmask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.microhard_util.MicrohardLanSettingsPb} returns this
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.setMhNetmask = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mh_gateway = 4;
 * @return {string}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.getMhGateway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.microhard_util.MicrohardLanSettingsPb} returns this
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.setMhGateway = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string computer_ip = 5;
 * @return {string}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.getComputerIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.microhard_util.MicrohardLanSettingsPb} returns this
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.setComputerIp = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string computer_netmask = 6;
 * @return {string}
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.getComputerNetmask = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.microhard_util.MicrohardLanSettingsPb} returns this
 */
proto.microhard_util.MicrohardLanSettingsPb.prototype.setComputerNetmask = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.microhard_util);
